import { connect, useSelector } from "react-redux";
import { redeemCoupon, resetCoupon } from "../store/action";
import { RedeemCouponInput } from "../store/actionType";
import { CommercialUserProps } from "modules/user_management/commercial_user/user/state/actionType";
import { InputForm, SubmitButton, Error, ApiError } from "components";
import { ChangeEvent, useEffect, useState } from "react";
import { MailInput } from "modules/email_log/store/actionType";
import { sendMail } from "modules/email_log/store/action";

interface OwnProps {
  userData: CommercialUserProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandelRedeemCoupon: React.FC<Props> = ({
  userData,
  onRedeemCoupon,
  onResetCoupon,
  onSendMail,
}) => {
  const couponState = useSelector(
    (state: any) => state.coupon.genericCouponState
  );
  const couponRedeemded = couponState?.redeemData;
  const [coupon, setCoupon] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [apiError, setApiError] = useState<string | null>(null);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCoupon(e.target.value);
    setError(""); // reset error on change
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!coupon.trim()) {
      setError("Coupon code is required");
      return;
    }
    setLoading(true);
    const input: RedeemCouponInput = {
      coupon_code: coupon.trim(),
      user_id: "f81c3b55-d7a5-42ef-9f12-1d05dea507c6",
    };
    const sendMailInput: MailInput = {
      to: userData?.email,
      subject: "Redeem Coupon",
      title: "Redeem Coupon",
      content: `Coupon : ${<strong className="font-bold">{coupon ? coupon : "Couldn't get coupon"} </strong>}`,
    };
    setSubmitted(true);
    onRedeemCoupon(input);
    onSendMail(sendMailInput);
    setLoading(false);
  };
  useEffect(() => {
    onResetCoupon();
    if (!couponState.isLoading && submitted) {
      if (couponState.error) {
        setApiError(couponState.error);
      } else {
        setApiError(null);
        setMessage("Coupon was Redeemed Successfully!");
      }
    }
  }, [couponState.isLoading, couponState.error, submitted]);
  return (
    <>
      {couponRedeemded ? (
        <div className="min-h-[20vh] flex justify-center items-center text-primary-400 text-xl font-semibold">
          {message}
        </div>
      ) : (
        <>
          <h2 className="text-sm text-primary-400">
            <strong className="text-black">Note : </strong>
            {apiError ? (
              <ApiError>{apiError}</ApiError>
            ) : (
              "Entering the Coupon Code and submitting will add the coupon to the above user"
            )}
          </h2>
          <form>
            <InputForm
              label="Enter Coupon Code"
              id="coupon_code"
              name="coupon_code"
              value={coupon}
              onChange={handleChange}
            />
            <div>
              <SubmitButton loading={loading} onClick={handleSubmit} />
              {error && <Error>{error}</Error>}
            </div>
          </form>
        </>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onRedeemCoupon: (input: RedeemCouponInput) => dispatch(redeemCoupon(input)),
  onSendMail: (sendMailInput: MailInput) => dispatch(sendMail(sendMailInput)),
  onResetCoupon: () => dispatch(resetCoupon()),
});

export default connect(null, mapDispatchToProps)(HandelRedeemCoupon);
